export default __webpack_public_path__ + "static/media/alessioedited.10f18238.webp";